import { map, mapValues, keyBy } from "lodash";

export default (
  state,
  {
    macroAllocationGroups,
    descendantTargetGroups,
    roleAreaGroups,
    descendantSupplyGroups,
  }
) => {
  const { parentGroupId, parentGroupType, groupLookup, groupTypesLookup } =
    state;

  return {
    ...mapValues(groupLookup, (g) => ({
      ...g,
      isSource: groupTypesLookup[g.type]?.isSupply ?? false,
      isDemand: groupTypesLookup[g.type]?.isDemand ?? false,
    })),
    ...keyBy(
      map(macroAllocationGroups, (g) => ({
        ...g,
        isSource: groupTypesLookup[g.type]?.isSupply ?? false,
        isDemand: groupTypesLookup[g.type]?.isDemand ?? false,
      })),
      "id"
    ),
    ...keyBy(
      map(descendantTargetGroups, (g) => ({
        ...g,
        isSource: groupTypesLookup[g.type]?.isSupply ?? false,
        isDemand: groupTypesLookup[g.type]?.isDemand ?? false,
      })),
      "id"
    ),
    ...keyBy(
      map(roleAreaGroups, (g) => ({
        ...g,
        isSource: groupTypesLookup[g.type]?.isSupply ?? false,
        isDemand: groupTypesLookup[g.type]?.isDemand ?? false,
      })),
      "id"
    ),
    ...keyBy(
      map(descendantSupplyGroups, (g) => ({
        ...g,
        isSource: groupTypesLookup[g.type]?.isSupply ?? false,
        isDemand: groupTypesLookup[g.type]?.isDemand ?? false,
      })),
      "id"
    ),
    ...keyBy(
      map(descendantSupplyGroups, (t) => ({
        id: `${t.id}-virtual-direct-constraint-grouping`,
        type: `Direct roles`,
        name: `Direct ${t.type} roles`,
        directRoles: true,
        isSource: true,
        isDemand: false,
        isVirtual: true,
      })),
      "id"
    ),
    [`${parentGroupId}-virtual-direct-constraint-grouping`]: {
      id: `${parentGroupId}-virtual-direct-constraint-grouping`,
      type: `Direct roles`,
      name: `Direct ${parentGroupType} roles`,
      directRoles: true,
      isSource: true,
      isDemand: false,
      isVirtual: true,
    },
  };
};
